import { BackButton } from '~/@pages_investing/project-detail/project-detail_ui/back-button/BackButton'
import { SophisticatedAgreementForm } from './SophisticatedAgreementForm'
import { StepHeadline } from '~/@pages_onboarding/_onboarding-stepper/StepHeadline'
import { Button } from '~/shadcn/ui/button/button'

type Props = {
  isLoading: boolean
  onSign(): void
  onUnsophisticated(): void
}

export function SophisticatedInvestorSignAgreement({
  isLoading,
  onSign,
  onUnsophisticated,
}: Props) {
  return (
    <>
      <div className="flex flex-col gap-10">
        <div className="flex justify-between items-center">
          <BackButton route="/">Späť</BackButton>
        </div>
        <div className="flex flex-col gap-5">
          <StepHeadline headingText="Skvelé, už chýba iba kúsok." />
          <p className="font-bold">
            Potvrďte informácie nižšie a prejdite k podpisu rámcovej zmluvy.
          </p>
        </div>
        <SophisticatedAgreementForm
          isSigningAgreement={isLoading}
          onSign={onSign}
        />
        <Button
          variant="outline"
          disabled={isLoading}
          size="xl"
          className="w-full lg:w-fit whitespace-normal min-w-0"
          onClick={onUnsophisticated}>
          Chcem pokračovať ako nesofistikovaný investor.
        </Button>
      </div>
    </>
  )
}
